import React, { Component } from "react";
import { withRouter } from '../../../../shared/hoc/withRouter';
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import PortletSpinner from "../../../../partials/layout/PortletSpinner";
import DataGrid, { Toolbar, Item as ToolbarItem, SearchPanel, Paging, ColumnChooser, ColumnFixing, Editing, HeaderFilter, FilterPanel, FilterRow, Grouping, Scrolling } from 'devextreme-react/data-grid';
import { withSnackbar } from 'notistack';
import * as settingsCrud from "../../../../crud/settings.crud";
import SystemHelper from "../../../../shared/systemHelper";
import { FormattedMessage, injectIntl } from "react-intl";
import { SpeedDialAction } from 'devextreme-react/speed-dial-action';
import SystemSettingsFilterModal from "./SystemSettingsFilterModal";
import { LoadPanel } from 'devextreme-react/load-panel';
import { Badge } from "react-bootstrap";
import SystemSettingsCreateModal, { RESPONSES as CreateModalResponses } from './SystemSettingsCreateModal';

import * as companiesCrud from '../../../../crud/companies.crud';
import * as contractsCrud from '../../../../crud/contracts.crud';


class System extends Component {

    constructor(props) {
        super(props);

        this.loadPanelRef = React.createRef();
        this.dataGrid = React.createRef();
        // this.companiesDataSource = this.getCompanyOptions();
        this.state = {
            settings: null,
            filter: null,
            filteredSettings: null,
            showFilterModal: false,
            showCreateModal: false,
            createModalKey: null,
            companiesList: [],
        }
    }

    componentDidMount() {
        this.fetchSettings();
    }
    getCompanyOptions = () => {
        return new Promise(async (resolve, reject) => {
            let { data: companiesList } = await companiesCrud.getCutDownCompaniesList();
            if (!companiesList || !companiesList.length > 0) {
                this.props.enqueueSnackbar('No companies found', { variant: 'warning', });
                resolve([]);
            }
            resolve(companiesList);
        });
    }
    fetchSettings = async () => {
        try {
            if (this.loadPanelRef.current) {
                this.loadPanelRef.current.instance().option("visible", true)
            }
            let { data: settings } = await settingsCrud.getSettingsRegisterList();
            let { data: companiesList } = await companiesCrud.getCutDownCompaniesList();
            companiesList = companiesList.map(company => ({ companyid: company.companyid, name: `[${company.companyid}] ${company.name}` }));
            let keyDescriptionsObject = {};
            let mappedItems = settings.map(item => {
                if (!keyDescriptionsObject[item.Key]) {
                    keyDescriptionsObject[item.Key] = item.Description;
                }
                let keyDisplay = `${item.GroupingMasterSettingsID.toString().padStart(4, '0')}-[${item.ParentSettingsID ? "B" : "A"}]-${item.Key} (${keyDescriptionsObject[item.Key]})`;

                return {
                    ...item,
                    MasterGroupingKeyDisplay: keyDisplay,
                }
            });


            // let settingsReduced = settings.reduce((itemsArray, settingCategory) => {
            //     let categoryItems = [...settingCategory.Server_Defaults, ...settingCategory.Company_Overrides, ...settingCategory.Contract_Overrides];
            //     let undoldedCategoryItems = [...categoryItems];

            //     categoryItems.forEach((item) => {
            //         undoldedCategoryItems.push(...item.Associated.map(associatedItem => ({ ...associatedItem, ParentID: item.SettingsID, ParentKey: item.Key })));
            //     });
            //     let mappedItems = undoldedCategoryItems.map(item => {
            //         if (!keyDescriptionsObject[item.Key]) {
            //             keyDescriptionsObject[item.Key] = item.Description;
            //         }

            //         let parentGroupingKey = item.ParentKey ? item.ParentKey : item.Key;
            //         let parentGroupingID = item.ParentID ? item.ParentID : item.SettingsID;
            //         let keyDisplay = `${parentGroupingID.toString().padStart(4, '0')}-[${item.ParentID ? "B" : "A"}]-${item.Key} (${keyDescriptionsObject[item.Key]})`;

            //         return {
            //             IsParent: !item.ParentID,
            //             ParentID: item.ParentID,
            //             ParentKey: item.ParentKey,
            //             ParentKeyDisplay: item.ParentKey ? `${item.ParentKey} (${keyDescriptionsObject[item.ParentKey]})` : null,
            //             ParentGroupingKey: parentGroupingKey,
            //             ParentGroupingID: parentGroupingID,
            //             SettingsID: item.SettingsID,
            //             Category: settingCategory.Category,
            //             Key: item.Key,
            //             KeyDisplay: keyDisplay,
            //             CompanyID: item.CompanyID,
            //             ContractID: item.ContractID,
            //             DataType: item.DataType,
            //             Description: item.Description,
            //             Group: item.Group,
            //             Value: item.Value,
            //         }
            //     });

            //     mappedItems = mappedItems.sort((a, b) => {
            //         return a.ParentGroupingKey.localeCompare(b.ParentGroupingKey)
            //             || ((a.IsParent === b.IsParent) ? 0 : a.IsParent ? -1 : 1)
            //             || a.Key.localeCompare(b.Key)
            //             || a.ParentID - b.ParentID;
            //     });
            //     // console.log("sorted mappedItems:", mappedItems);
            //     itemsArray.push(...mappedItems);
            //     return itemsArray;
            // }, []);
            // console.log(settingsReduced);
            this.setState({ settings: mappedItems, filteredSettings: null, filter: null, companiesList });
        } catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            this.setState({ settings: null, filteredSettings: null, filter: null });
        }
        finally {
            if (this.loadPanelRef.current) {
                this.loadPanelRef.current.instance().option("visible", false)
            }
        }
    }

    onRowPrepared = (e) => {
        if (e.rowType === "data" && e.rowElement) {
            if (e.data?.Group === "SERVER") {
                e.rowElement.style.backgroundColor = '#E9EAEC';
            }
        }
        else if (e.rowType === "group" && e.rowElement && e.groupIndex === 1) {
            if (e.data?.key?.includes("[A]")) {
                e.rowElement.style.backgroundColor = '#E9EAEC';
            }
            else {
                e.rowElement.style.backgroundColor = '#ffeeba';
            }
            // e.cells[2].displayValue += " Some Custom Text";
            // e.cells[2].displayValue = "Some Custom Text " + e.cells[2].displayValue;
            // e.rowElement.textContent += "Custom Text";
            // console.log(e);
        }
    }
    allowDeleting = (e) => {
        return e.row.data.Group !== "SERVER" && !e.row.data.ParentSettingsID;
    }
    allowEditing = (e) => {
        return e.row.data.ReadOnly !== true;
    }
    allowAdding = (e) => {
        return e.row.data.Group === "SERVER" && e.row.data.OverrideAllowed && !e.row.data.ParentSettingsID;
    }
    deleteSettingPromise = (settingsid) => {
        return new Promise(async (resolve, reject) => {
            try {
                await settingsCrud.deleteSetting(settingsid);
                resolve(false);
            } catch (error) {
                console.log(error);
                reject(error)
            }
        });
    }
    //deleting row
    onRowRemoving = async (e) => {
        e.cancel = this.deleteSettingPromise(e.data.SettingsID);
    }
    filterDialogResult = async (filter) => {
        if (filter) {
            let companyid = filter.showsystemdefaults ? 0 : (filter.companyid ?? 0);
            let contractid = filter.showsystemdefaults ? 0 : (filter.contractid ?? 0);
            let { data: settingsApplied } = await settingsCrud.getSettingsApplied(companyid, contractid);
            let settingIDsApplied = settingsApplied.map(item => item.SettingsID);
            let filteredSettings = this.state.settings.filter(item => settingIDsApplied.includes(item.SettingsID));

            this.setState({ filter, showFilterModal: false, filteredSettings }, () => {
                if (this.dataGrid.current) {
                    this.dataGrid.current.instance().expandAll();
                }
            });
        }
        else {
            this.setState({ filter: null, showFilterModal: false, filteredSettings: null });
        }
    }
    createDialogResult = (result) => {
        if (result === CreateModalResponses.SAVE) {
            this.fetchSettings();
        }
        this.setState({ showCreateModal: false, createModalKey: null });
    }
    validateSettingValue = (oldData, newValue) => {
        let validationResult = { isValid: true, message: "" };
        if (oldData.Mandatory === true && (newValue === null || newValue === undefined || newValue === "")) {
            validationResult.isValid = false;
            validationResult.message = "This field is mandatory.";
        }
        else if (oldData.DataType === "BOOLEAN") {
            if (newValue !== "TRUE" && newValue !== "FALSE") {
                validationResult.isValid = false;
                validationResult.message = "Invalid value for BOOLEAN type. Please enter 'TRUE' or 'FALSE'.";
            }
        }
        else if (oldData.DataType === "INTEGER") {
            if (isNaN(newValue) || !Number.isInteger(Number(newValue))) {
                validationResult.isValid = false;
                validationResult.message = "Invalid value for INTEGER type. Please enter a valid number.";
            }
        }
        return validationResult;
    }
    onRowUpdating = (e) => {
        if (e.newData.Value !== undefined) {
            e.cancel = new Promise(async (resolve, reject) => {
                let validationResult = this.validateSettingValue(e.oldData, e.newData.Value);
                if (!validationResult.isValid) {
                    reject(validationResult.message);
                    return;
                }
                try {
                    let payload = {
                        SettingsID: e.oldData.SettingsID,
                        Value: e.newData.Value,
                    }
                    await settingsCrud.updateSetting(payload);
                    resolve(false);
                } catch (error) {
                    console.log("errormfrom update",error);
                    reject(error);
                }
            });
        }
    };
    render() {
        if (!this.state.settings) {
            return <PortletSpinner />;
        }

        return (
            <Portlet>
                <PortletBody>
                    <LoadPanel
                        ref={this.loadPanelRef}
                        shadingColor="rgba(0,0,0,0.4)"
                        message='Loading system settings'
                        showIndicator={true}
                        shading={true}
                        showPane={true}
                        hideOnOutsideClick={false}
                    />
                    <DataGrid
                        ref={this.dataGrid}
                        dataSource={this.state.filteredSettings || this.state.settings}
                        keyExpr="SettingsID"
                        hoverStateEnabled={true}
                        rowAlternationEnabled={false}
                        noDataText={'No Data'}
                        remoteOperations={false}
                        allowColumnReordering={false}
                        allowColumnResizing={true}
                        onRowRemoved={this.fetchSettings}
                        //onToolbarPreparing={this.state.currentToolbarRenderer}
                        onRowRemoving={this.onRowRemoving}
                        onRowPrepared={this.onRowPrepared}
                        onRowUpdating={this.onRowUpdating}
                        // cell
                        columns={[
                            {
                                caption: "ID",
                                dataField: "SettingsID",
                                allowGrouping: false,
                                visible: false,
                                allowEditing: false,
                            },
                            {
                                caption: "Category",
                                dataField: "CategoryName",
                                groupIndex: 0,
                                allowEditing: false,
                            },
                            {
                                caption: "Key",
                                dataField: "MasterGroupingKeyDisplay",
                                groupIndex: 1,
                                allowEditing: false,
                            },
                            {
                                caption: "Group",
                                dataField: "Group",
                                allowGrouping: false,
                                allowEditing: false,
                                width: 100,
                            },
                            {
                                caption: "CompanyID",
                                dataField: "CompanyID",
                                allowGrouping: false,
                                allowEditing: false,
                                width: 200,
                                lookup: {
                                    dataSource: this.state.companiesList,
                                    displayExpr: "name",
                                    valueExpr: "companyid",
                                }
                            },
                            {
                                caption: "ContractID",
                                dataField: "ContractID",
                                allowGrouping: false,
                                allowEditing: false,
                                width: 100,
                            },
                            {
                                caption: "DataType",
                                dataField: "DataType",
                                allowGrouping: false,
                                allowEditing: false,
                                width: 100,
                            },
                            {
                                caption: "Value",
                                dataField: "Value",
                                allowGrouping: false,
                                allowEditing: true,
                            },
                            {
                                name: "editButtons",
                                type: "buttons",
                                buttons: [
                                    {
                                        name: "add",
                                        visible: this.allowAdding,
                                        onClick: (e) => {
                                            e.event.stopPropagation();
                                            this.setState({ showCreateModal: true, createModalKey: e.row.data.Key });

                                        }
                                    },
                                    {
                                        name: "edit",
                                        // visible: (e) => this.allowEditing(e), 
                                    },
                                    {
                                        name: "delete",
                                        // visible: (e) => this.allowDeleting(e), 
                                    }
                                ]

                            }
                        ]}
                    >
                        <Scrolling mode="virtual" showScrollbar={true} useNative={true} columnRenderingMode="virtual" rowRenderingMode="virtual" />

                        <Grouping
                            autoExpandAll={false}
                            contextMenuEnabled={false}
                            expandMode="rowClick"
                        />
                        <Editing
                            mode="row"
                            allowUpdating={this.allowEditing}
                            allowDeleting={this.allowDeleting}
                            confirmDelete={true}
                            useIcons={true}
                            allowAdding={false}
                            selectTextOnEditStart={true}
                            texts={{
                                deleteRow: this.props.intl.formatMessage({ id: "GENERAL.FORMS.REMOVE" }),
                                confirmDeleteTitle: "Deleting Custom Override Setting",
                                confirmDeleteMessage: "You are about to delete this custom override setting. Are you sure you want to proceed?",
                            }}
                        />
                        {/* <HeaderFilter visible={true} /> */}
                        {/* <FilterPanel visible={true} /> */}
                        {/* <FilterRow applyFilter="auto" visible={true} /> */}
                        {/* <ColumnChooser enabled={true} /> */}
                        {/* <ColumnFixing enabled={true} /> */}
                        <SearchPanel visible={true} highlightCaseSensitive={false} defaultText="" />
                        {/* <Paging pageSize={10} defaultPageSize={10} defaultPageIndex={0} /> */}
                        <Toolbar>
                            <ToolbarItem location="before">
                                <div>
                                    <h3 style={{ fontFamily: SystemHelper.getThemeTextFont() ?? 'Poppins, Helvetica, sans-serif', fontSize: '1.2rem', fontWeight: 500, color: '#48465b', padding: 0, margin: 0, lineHeight: 1.2 }} className="kt-portlet__head-title">
                                        System Settings
                                    </h3>
                                </div>
                            </ToolbarItem>
                            <ToolbarItem
                                location="before"
                                visible={this.state.filter !== null}
                            >
                                <div>
                                    <Badge style={{ marginLeft: 5 }} variant="warning">{
                                        this.state.filter?.contractid ? `Contract: ${this.state.filter.contractid}` :
                                            this.state.filter?.companyid ? `Company: ${this.state.filter.companyid}` :
                                                this.state.filter?.showsystemdefaults ? "System Defaults" : ""
                                    }</Badge>
                                </div>
                            </ToolbarItem>



                            <ToolbarItem location="after"
                                locateInMenu="auto"
                                name="addAction"
                                showText="always"
                                widget="dxButton"
                                options={{
                                    icon: "plus",
                                    text: "Add Custom Setting",
                                    onClick: () => this.setState({ showCreateModal: true }),
                                }}
                            />

                            <ToolbarItem
                                location="after"
                                locateInMenu="always"
                                widget="dxButton"
                                options={{
                                    icon: "refresh",
                                    text: this.props.intl.formatMessage({ id: "GENERAL.BUTTON.REFRESH" }),
                                    onClick: this.fetchSettings,
                                }}
                            />
                            {/* <ToolbarItem
                                location="after"
                                locateInMenu="always"
                                render={this.renderToolbarSwitchArchive}
                            /> */}
                            <ToolbarItem location="after"
                                locateInMenu="auto"
                                name="searchPanel"
                            />
                        </Toolbar>
                    </DataGrid>
                    <SpeedDialAction
                        icon="eyeopen"
                        label="View Applied Settings"
                        index={1}
                        visible={this.state.filter === null}
                        onClick={() => this.setState({ showFilterModal: true })}
                    />
                    <SpeedDialAction
                        icon="remove"
                        label="Remove Filter"
                        index={2}
                        visible={this.state.filter !== null}
                        onClick={() => {
                            this.setState({ filter: null, filteredSettings: null }, () => {
                                if (this.dataGrid.current) {
                                    this.dataGrid.current.instance().collapseAll();
                                }
                            });
                        }}
                    />
                    <SystemSettingsFilterModal
                        visible={this.state.showFilterModal}
                        onDialogResult={this.filterDialogResult}
                    />
                    <SystemSettingsCreateModal
                        visible={this.state.showCreateModal}
                        onDialogResult={this.createDialogResult}
                        preselectedKey={this.state.createModalKey}
                    />
                </PortletBody>
            </Portlet>
        );
    }
}

export default injectIntl(withSnackbar(withRouter(System)));
